document.querySelectorAll('[data-accordion]').forEach(accordion => {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    const container = accordion.querySelector('[data-accordion-container]');
    const body = accordion.querySelector('[data-accordion-body]');

    let opened = container.getAttribute('aria-expanded') === 'true';
    let bodyHeight = 0;

    function update() {
        if (opened) {
            accordion.dataset.accordion = 'opened';
            container.style.height = bodyHeight + 'px';
            container.hidden = false;
            container.setAttribute('aria-expanded', 'true');
        }
        else {
            accordion.dataset.accordion = '';
            container.style.height = '0';
            container.hidden = true;
            container.setAttribute('aria-expanded', 'false');
        }
    }

    update();

    new ResizeObserver(entries => {
        console.log(entries);
        bodyHeight = entries[0].borderBoxSize[0].blockSize;
        console.log(bodyHeight);
        update();
    }).observe(body);

    trigger.addEventListener('click', () => {
        opened = !opened;
        update();
    });
});
